const _Looper = require("util/Looper");
const _HTML = require("util/Html");
const _Misc = require("util/Misc");

class UIComponent{
    constructor(parentSel, HTML, addFirst, resource) {
        if(resource)
            this.resource = resource;
        this.id = _HTML.insert(parentSel, HTML, this.resource, addFirst);
        this.$self = $("#" + this.id, parentSel);
        if(this.$self.length === 0)
            this.$self = $("#" + this.id);
        if(this.$self.length === 0)
            this.$self = parentSel;
        this.$self.addClass("hidden");
        this.ready = false;
        this.initializedChildrenCount = 0;
        this.childrenCount = 0;
        this.children = [];
        _Misc.callLater(this.initialize.bind(this));
    };

    initialize(showPending, requireInputHelper, requireFirebase, requireL2Modules, requireCharts){
        this.showPending = showPending || false;
        this.requireInputHelper = requireInputHelper || false;
        this.requireFirebase = requireFirebase || false;
        this.requireL2Modules = requireL2Modules || false;
        this.requireCharts = requireCharts || false;

        if((this.requireFirebase || this.requireCharts)){
           this.hasExternalDependencies(); // Creation process paused
        }
        else{
            _Misc.callLater(this.createChildren.bind(this));
        }
    };

    createChildren(kids){
        if(kids && kids.length > 0){
            this.childrenCount = kids.length;
            this.children = kids;
            _Looper.array(kids, function(kid, idx){
                kid.onInitialized = function(){
                    this.initializedChildrenCount++;
                    this.preInitialized();
                }.bind(this);
            }.bind(this));
        }
        _Misc.callLater(this.addEventListeners.bind(this));
    };

    addEventListeners(){
        _Misc.callLater(this.preInitialized.bind(this));
    }

    preInitialized(){
        if(this.childrenCount > 0){
            if(this.childrenCount > this.initializedChildrenCount)
                return;//CHILDREN NOT YET READY, NEED TO WAIT.
        }
        _Misc.callLater(this.initialized.bind(this));
    }

    initialized(){
        this.ready = true;
        if(this.showPending){
            this.show();
        }
        if(this.onInitialized){
            this.onInitialized();
        }
        if(this.readyOnDOM){
            this.readyOnDOM();
        }
    };

    // generic function:
    show() {
        this.showPending = false;
        if (this.ready) {
            if(this.$self.hasClass("hidden")){
                this.$self.removeClass("hidden").addClass("animated quick fadeIn");
                _Misc.callLater(function () {
                    this.readyOnScreen();
                    this.$self.removeClass("animated quick fadeIn");
                }.bind(this), 250);
                if (this.scrollTop) {
                    _Misc.scrollToTop();
                }
            }
        }
        else {
            this.showPending = true;
        }
    };

    hide() {
        this.$self.addClass("hidden");
    };

    addChild(html, wrapperSel, addFirst, resource, after){
        wrapperSel = (wrapperSel) ? $(wrapperSel, this.$self) : this.$self;
        return _HTML.insert(wrapperSel, html, resource, addFirst, after);
    };

    pathChanged(l1, l2, l3, l4, l5){
        if(this.children){
            _Looper.array(this.children, function(child){
                child.pathChanged(l1, l2, l3, l4, l5);
            });
        }
    }; // called when URL changes
    readyOnScreen(){/* called after show effect is done */};
    readyOnDOM(){ /* SHOULD ONLY BE USED BY ROUTER.*/ };
    hasExternalDependencies(){ /* SHOULD ONLY BE USED BY ROUTER.*/ };
}

module.exports = UIComponent;



// WEBPACK FOOTER //
// ./src/control/base/UIComponent.js